class WithdrawalForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.apiUrl = this.dataset.apiUrl || '';
    this.submitButton = this.form.querySelector('[type="submit"]');
    this.statusEl = this.querySelector('[data-withdrawal-status]');
    this.fieldsEl = this.querySelector('[data-withdrawal-fields]');
    this.receiptEl = this.querySelector('[data-withdrawal-receipt]');

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  setBusy(isBusy) {
    if (!this.submitButton) return;
    this.submitButton.disabled = isBusy;
    this.submitButton.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  showError(message) {
    if (!this.statusEl) return;
    if (!message) {
      this.statusEl.hidden = true;
      this.statusEl.textContent = '';
      return;
    }
    this.statusEl.hidden = false;
    this.statusEl.classList.remove('withdrawal-form__status--success');
    this.statusEl.classList.add('withdrawal-form__status--error');
    this.statusEl.textContent = message;
  }

  showReceipt(payload) {
    if (this.fieldsEl) this.fieldsEl.hidden = true;
    if (this.statusEl) this.statusEl.hidden = true;
    if (!this.receiptEl) return;

    const detail = this.receiptEl.querySelector('[data-withdrawal-detail]');
    if (detail && payload?.message) {
      detail.textContent = payload.message;
    }

    const meta = this.receiptEl.querySelector('[data-withdrawal-meta]');
    if (meta) {
      const stamp = new Date();
      const formatted = `${stamp.getFullYear()}-${String(stamp.getMonth() + 1).padStart(2, '0')}-${String(
        stamp.getDate()
      ).padStart(2, '0')} ${String(stamp.getHours()).padStart(2, '0')}:${String(stamp.getMinutes()).padStart(2, '0')}`;
      const label = meta.dataset.timeLabel || 'Registrerad';
      meta.textContent = `${label}: ${formatted}`;
    }

    this.receiptEl.hidden = false;
    this.receiptEl.focus();
  }

  async onSubmit(event) {
    event.preventDefault();

    if (!this.apiUrl) {
      this.showError(
        this.dataset.missingApi ||
          'Ångertjänsten är inte konfigurerad ännu. Kontakta butiken eller sätt API-URL i temat.'
      );
      return;
    }

    const formData = new FormData(this.form);
    const payload = {
      orderNumber: String(formData.get('orderNumber') || '').trim(),
      email: String(formData.get('email') || '').trim(),
      name: String(formData.get('name') || '').trim(),
      message: String(formData.get('message') || '').trim(),
    };

    this.setBusy(true);
    this.showError('');
    if (this.statusEl) this.statusEl.hidden = true;

    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok || !data.ok) {
        this.showError(data.error || this.dataset.genericError || 'Något gick fel. Försök igen.');
        return;
      }

      this.showReceipt(data);
    } catch (error) {
      console.error(error);
      this.showError(
        this.dataset.networkError ||
          'Kunde inte nå ångertjänsten. Kontrollera att den körs och försök igen.'
      );
    } finally {
      this.setBusy(false);
    }
  }
}

customElements.define('withdrawal-form', WithdrawalForm);
